import { render, staticRenderFns } from "./btnBox.vue?vue&type=template&id=31f73815&scoped=true"
import script from "./btnBox.vue?vue&type=script&lang=js"
export * from "./btnBox.vue?vue&type=script&lang=js"
import style0 from "./btnBox.vue?vue&type=style&index=0&id=31f73815&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f73815",
  null
  
)

export default component.exports